module.exports = __webpack_public_path__ + "img/qr-menu-dark.71adf2d2.svg";